// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-47730df5] .ant-transfer-list-body-customize-wrapper {\n  padding: 0;\n}\n[data-v-47730df5] .ant-transfer-list {\n  overflow-y: auto;\n}", ""]);
// Exports
module.exports = exports;
